// import { RequireAutorization } from './routerAuth'

export default {
  name: 'Franchisees',
  path: '/franqueados',
  component: () => import(/* webpackChunkName: "Franchisees" */ '@apps/franchisees/Index.vue'),
  meta: { title: 'Franqueados' },
  children: [
    {
      path: 'criar',
      name: 'FranchiseeNew',
      component: () => import(/* webpackChunkName: "Franchisees" */'@apps/franchisees/New.vue'),
      meta: { title: 'Criar Franqueado' },
    },
    {
      path: ':franchiseeId',
      name: 'FranchiseeShow',
      component: () => import(/* webpackChunkName: "Franchisees" */'@apps/franchisees/Show.vue'),
      meta: { title: 'Exibir Franqueado' },
    },
    {
      path: 'franchiseeId/editar',
      name: 'FranchiseeEdit',
      component: () => import(/* webpackChunkName: "Franchisees" */'@apps/franchisees/Edit.vue'),
      meta: { title: 'Editar Franqueado' },
    },
  ],
  // beforeEnter: RequireAutorization
}
